import { API_BASE_URL, DEFAULT_HEADERS } from '../config';
import { httpClient } from '../api/httpClient';

// Проверяем, есть ли токен авторизации или это Telegram WebApp
const hasAuthToken = () => {
    // Если это Telegram WebApp, считаем что авторизация есть
    if (window.Telegram?.WebApp?.initData) {
        return true;
    }
    
    // Иначе проверяем обычные токены
    return !!localStorage.getItem('access_token') || !!localStorage.getItem('refresh_token');
};

// Отладочная информация

const handleError = (error) => {
    throw error;
};

const fetchClient = {
    get: async (url) => {
        try {
            // НЕ перезаписываем заголовки авторизации от httpClient
            // Добавляем только дополнительные заголовки
            const additionalHeaders = {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            };

            const separator = url.includes('?') ? '&' : '?';
            const fullUrl = `${API_BASE_URL}${url}${separator}_t=${Date.now()}`;

            const response = await httpClient.get(fullUrl, { headers: additionalHeaders });
            console.log('📡 Response status:', response.status, response.statusText);

            if (!response.ok) {
                const errorData = await response.json().catch(() => null);
                const error = new Error(errorData?.detail || response.statusText);
                error.response = {
                    status: response.status,
                    data: errorData
                };
                console.error('❌ API Error:', error);
                throw error;
            }

            const data = await response.json();
            console.log('✅ API Success:', data);
            return data;
        } catch (error) {
            console.error('❌ Request error:', error);
            throw error;
        }
    },

    post: async (url, data) => {
        try {
            // НЕ перезаписываем заголовки авторизации от httpClient
            // Добавляем только дополнительные заголовки
            const additionalHeaders = {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            };

            const fullUrl = `${API_BASE_URL}${url}`;
            const response = await httpClient.post(fullUrl, data, { headers: additionalHeaders });

            if (!response.ok) {
                const errorData = await response.json().catch(() => null);
                const error = new Error(errorData?.detail || response.statusText);
                error.response = {
                    status: response.status,
                    data: errorData
                };
                throw error;
            }

            return response.json();
        } catch (error) {
            console.error('Request error:', error);
            throw error;
        }
    },

    put: async (url, data) => {
        try {
            // НЕ перезаписываем заголовки авторизации от httpClient
            // Добавляем только дополнительные заголовки
            const additionalHeaders = {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            };

            const fullUrl = `${API_BASE_URL}${url}`;
            const response = await httpClient.put(fullUrl, data, { headers: additionalHeaders });

            if (!response.ok) {
                const errorData = await response.json().catch(() => null);
                const error = new Error(errorData?.detail || response.statusText);
                error.response = {
                    status: response.status,
                    data: errorData
                };
                throw error;
            }

            return response.json();
        } catch (error) {
            console.error('Request error:', error);
            throw error;
        }
    },

    delete: async (url) => {
        try {
            // НЕ перезаписываем заголовки авторизации от httpClient
            // Добавляем только дополнительные заголовки
            const additionalHeaders = {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            };

            const fullUrl = `${API_BASE_URL}${url}`;
            const response = await httpClient.delete(fullUrl, { headers: additionalHeaders });

            if (!response.ok) {
                const errorData = await response.json().catch(() => null);
                const error = new Error(errorData?.detail || response.statusText);
                error.response = {
                    status: response.status,
                    data: errorData
                };
                throw error;
            }

            return response.json();
        } catch (error) {
            console.error('Request error:', error);
            throw error;
        }
    }
};

// Экспорт request функции для совместимости со старыми API файлами
export const request = async (url, options = {}) => {
    const { method = 'GET', data, body, headers } = options;
    
    // Если есть body, парсим его как JSON
    let requestData = data;
    if (body && !data) {
        try {
            requestData = JSON.parse(body);
        } catch (e) {
            console.error('Error parsing body as JSON:', e);
            requestData = body;
        }
    }
    
    switch (method.toUpperCase()) {
        case 'GET':
            return fetchClient.get(url);
        case 'POST':
            return fetchClient.post(url, requestData);
        case 'PUT':
            return fetchClient.put(url, requestData);
        case 'DELETE':
            return fetchClient.delete(url);
        default:
            throw new Error(`Unsupported HTTP method: ${method}`);
    }
};

export default fetchClient; 